import { supabase } from './supabaseClient.js';

// Importar entidades do Supabase ao invés do base44
export {
    Client,
    Ticket,
    TicketComment,
    Project,
    ProjectTask,
    KnowledgeBase,
    Company,
    Invoice,
    Payment,
    AuditLog,
    System,
    SystemVersion,
    CompanySystemEntity as CompanySystem,
    UserMessage,
    UserFavorite,
    UserNotification,
    UserCalendarEvent,
    TimesheetEntry,
    ChatMessage,
    User,
    Dashboard,
    Search
} from './supabaseEntities.js';

// Função para deletar cliente por ID
export async function deleteClient(clientId) {
  console.log('[deleteClient] Tentando excluir cliente com id:', clientId);
  const { data, error } = await supabase
    .from('clients')
    .delete()
    .eq('id', clientId);
  if (error) {
    console.error('[deleteClient] Erro ao excluir:', error);
    throw error;
  }
  console.log('[deleteClient] Exclusão realizada:', data);
  return data;
}